import { useEffect } from 'react';

import { HAS_SEGMENTATION_FLAG } from 'core';
import { actions as contentActions } from 'core/use-cases/content/slice';
import { useQueryState } from 'core/use-cases/utilities';
import { useDispatch } from 'react-redux';
import { useGetFeatureFlag } from 'ui/hooks';

import { useContentSelector } from '../selectors';
import { actions } from '../slice';

export function useContent(pageType: string) {
  const dispatch = useDispatch();

  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(
    useContentSelector,
    pageType,
  );

  const { value: hasSegmentation, loading } = useGetFeatureFlag(HAS_SEGMENTATION_FLAG, false);

  useEffect(() => {
    dispatch(contentActions.contentCleanUp(pageType));
  }, []);

  useEffect(() => {
    if (!loading) {
      hasSegmentation
        ? dispatch(actions.starlinkPageFetch.request({ document: pageType }))
        : dispatch(actions.contentFetch.request(pageType));
    }

    return () => {
      dispatch(contentActions.contentCleanUp(pageType));
    };
  }, [loading, hasSegmentation]);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}
